import { RootState } from '@store/rootReducer'

export const selectDrafts = (state: RootState) => {
    return state.drafts.projects;
} 

export const selectDraftById =
  (projectId: string) =>
  (state: RootState) => {
    return state.drafts.projects.find(
      (p) => p.projectId === projectId
    );
  };
